<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 507 103" fill="none" aria-hidden="true">
    <path
      d="M503.683 0H2.96641C1.33967 0 0 1.30777 0 2.9664V99.9328C0 101.56 1.30777 102.899 2.96641 102.899H503.683C506.075 102.899 507.479 100.22 506.107 98.2422L474.625 53.1401C473.923 52.1194 473.923 50.7798 474.625 49.7591L506.107 4.65694C507.479 2.71123 506.075 0 503.683 0Z"
      :fill="backgroundColor"
    />
    <path d="M46.9202 41.7849H39.2011V36.7452H61.1462V41.7849H53.4271V65.3248H46.9202V41.7849Z" :fill="color" />
    <path
      d="M71.1618 36.7452H81.4007C88.1628 36.7452 92.437 39.4884 92.437 45.4212V45.5807C92.437 49.8867 89.9171 52.1833 86.5679 53.1721L94.1275 65.3248H87.2697L80.4438 54.2885H77.6368V65.3248H71.1937V36.7452H71.1618ZM81.2412 49.8867C84.4628 49.8867 86.1214 48.5152 86.1214 45.772V45.6126C86.1214 42.678 84.3671 41.6892 81.2412 41.6892H77.6049V49.8867H81.2412Z"
      :fill="color"
    />
    <path
      d="M103.314 54.1609V36.7452H109.821V53.7781C109.821 58.5308 111.224 60.6041 115.148 60.6041C119.071 60.6041 120.666 58.7541 120.666 53.523V36.7452H127.173V53.9376C127.173 61.7205 122.803 65.7714 115.116 65.7714C107.428 65.7714 103.314 61.7843 103.314 54.1928V54.1609Z"
      :fill="color"
    />
    <path
      d="M137.188 56.3618H143.376C143.663 58.9135 144.748 61.0506 148.958 61.0506C151.797 61.0506 153.679 59.4877 153.679 57.2549C153.679 55.0221 152.467 54.1928 148.288 53.523C140.984 52.5661 137.986 50.3652 137.986 44.847C137.986 39.9668 142.068 36.3306 148.384 36.3306C154.7 36.3306 158.559 39.2013 159.101 44.8789H153.137C152.722 42.2953 151.223 41.0832 148.384 41.0832C145.545 41.0832 144.11 42.391 144.11 44.3048C144.11 46.3462 145.035 47.3031 149.437 47.941C156.358 48.8341 159.899 50.6841 159.899 56.6169C159.899 61.6885 155.752 65.7394 148.99 65.7394C141.143 65.7394 137.571 62.0713 137.188 56.3618Z"
      :fill="color"
    />
    <path d="M175.305 41.7849H167.586V36.7452H189.531V41.7849H181.812V65.3248H175.305V41.7849Z" :fill="color" />
    <path
      d="M199.546 36.7452H218.174V41.7849H205.99V48.4514H215.75V53.1721H205.99V60.2851H218.812V65.3248H199.546V36.7452Z"
      :fill="color"
    />
    <path
      d="M229.306 36.7452H238.652C248.668 36.7452 253.644 42.1676 253.644 50.716V51.0349C253.644 59.5833 248.636 65.2928 238.62 65.2928H229.306V36.7133V36.7452ZM238.397 60.285C244.138 60.285 246.881 57.0634 246.881 51.1306V50.8117C246.881 44.9426 244.362 41.7849 238.333 41.7849H235.781V60.285H238.429H238.397Z"
      :fill="color"
    />
    <path
      d="M277.343 56.3618H283.531C283.818 58.9135 284.902 61.0506 289.113 61.0506C291.952 61.0506 293.834 59.4877 293.834 57.2549C293.834 55.0221 292.621 54.1928 288.443 53.523C281.139 52.5661 278.14 50.3652 278.14 44.847C278.14 39.9668 282.223 36.3306 288.539 36.3306C294.854 36.3306 298.714 39.2013 299.256 44.8789H293.291C292.877 42.2953 291.378 41.0832 288.539 41.0832C285.7 41.0832 284.265 42.391 284.265 44.3048C284.265 46.3462 285.19 47.3031 289.591 47.941C296.513 48.8341 300.053 50.6841 300.053 56.6169C300.053 61.6885 295.907 65.7394 289.145 65.7394C281.298 65.7394 277.726 62.0713 277.343 56.3618Z"
      :fill="color"
    />
    <path d="M310.866 36.7452H317.373V65.3248H310.866V36.7452Z" :fill="color" />
    <path d="M335.267 41.7849H327.548V36.7452H349.493V41.7849H341.774V65.3248H335.267V41.7849Z" :fill="color" />
    <path d="M365.251 41.7849H357.531V36.7452H379.477V41.7849H371.758V65.3248H365.251V41.7849Z" :fill="color" />
    <path
      d="M389.492 36.7452H408.12V41.7849H395.935V48.4514H405.696V53.1721H395.935V60.2851H408.758V65.3248H389.492V36.7452Z"
      :fill="color"
    />
    <path
      d="M419.252 36.7452H429.491C436.253 36.7452 440.527 39.4884 440.527 45.4212V45.5807C440.527 49.8867 438.007 52.1833 434.658 53.1721L442.218 65.3248H435.36L428.534 54.2885H425.727V65.3248H419.284V36.7452H419.252ZM429.331 49.8867C432.553 49.8867 434.211 48.5152 434.211 45.772V45.6126C434.211 42.678 432.457 41.6892 429.331 41.6892H425.695V49.8867H429.331Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'TrustedSitterBannerIcon',
  props: {
    width: {
      type: Number,
      default: 148,
    },
    height: {
      type: Number,
      default: 30,
    },
    color: {
      type: String,
      default: '#FFFFFF',
    },
    backgroundColor: {
      type: String,
      default: '#FF0064',
    },
  },
};
</script>
